module.exports = __webpack_public_path__ + "static/img/免押金.68688a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/user/center/免押金.png
// module id = 61
// module chunks = 18